import React from 'react';
import { Link } from 'react-router-dom';
import { Target, Eye, Heart, Award, Users, Clock, ArrowRight, CheckCircle } from 'lucide-react';

const About = () => {
  const values = [
    {
      icon: Heart,
      title: 'Güvenilirlik',
      description: 'İş ortaklarımızla şeffaf ve dürüst ilişkiler kurarak güven inşa ediyoruz.'
    },
    {
      icon: Award,
      title: 'Profesyonellik',
      description: 'Her aşamada yüksek standartlarda hizmet sunmayı ilke ediniyoruz.'
    },
    {
      icon: Users,
      title: 'İnsan Odaklılık',
      description: 'Çalışanların ve iş ortaklarının memnuniyetini ön planda tutuyoruz.'
    },
    {
      icon: Clock,
      title: 'Çözüm Odaklılık',
      description: 'Hızlı ve etkili çözümlerle müşterilerimizin ihtiyaçlarını karşılıyoruz.'
    },
  ];

  return (
    <div data-testid="about-page" className="pt-20">
      {/* Hero Section */}
      <section className="section-spacing bg-gradient-to-br from-[#2A9D8F]/5 to-[#E76F51]/5">
        <div className="section-container">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <span className="inline-block px-4 py-2 bg-[#2A9D8F]/10 text-[#2A9D8F] rounded-full text-sm font-medium mb-6">
                Hakkımızda
              </span>
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#264653] mb-6 font-['Outfit']">
                BDHA <span className="text-[#2A9D8F]">Danışmanlık</span>
              </h1>
              <p className="text-lg text-[#264653]/70 leading-relaxed mb-8">
                İnsan gücünün gerektiği alanlarda çalışan firmalara personel ile ilgili tüm 
                ihtiyaçlarını karşılamak, bu yönde firmanın asıl hedefine ve amacına 
                odaklanmasını sağlamak amacıyla kurulmuş profesyonel bir danışmanlık firmasıyız.
              </p>
              <div className="flex items-center gap-6">
                <div>
                  <p className="text-4xl font-bold text-[#E76F51] font-['Outfit']">5+</p>
                  <p className="text-[#264653]/60">Yıllık Deneyim</p>
                </div>
                <div className="w-px h-12 bg-[#264653]/20"></div>
                <div>
                  <p className="text-4xl font-bold text-[#E76F51] font-['Outfit']">200+</p>
                  <p className="text-[#264653]/60">Mutlu Müşteri</p>
                </div>
              </div>
            </div>
            <div className="relative">
              <img
                src="https://images.pexels.com/photos/3184287/pexels-photo-3184287.jpeg"
                alt="BDHA Ekibi"
                className="rounded-3xl shadow-xl w-full object-cover h-[450px]"
              />
              <div className="absolute -bottom-6 -left-6 bg-white p-6 rounded-2xl shadow-xl">
                <p className="text-sm text-[#264653]/60 mb-1">İstanbul, Türkiye</p>
                <p className="font-semibold text-[#264653]">Beykoz Merkez Ofis</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Mission & Vision */}
      <section className="section-spacing" data-testid="mission-vision-section">
        <div className="section-container">
          <div className="grid md:grid-cols-2 gap-8">
            <div className="p-8 rounded-3xl bg-[#2A9D8F]/5 border border-[#2A9D8F]/10">
              <div className="w-14 h-14 bg-[#2A9D8F]/10 rounded-2xl flex items-center justify-center mb-6">
                <Target className="text-[#2A9D8F]" size={28} />
              </div>
              <h2 className="text-2xl font-bold text-[#264653] mb-4 font-['Outfit']">Misyonumuz</h2>
              <p className="text-[#264653]/70 leading-relaxed">
                Firmaların süre kısıtlamalı işlerindeki personel eksikliğini, kaliteli ve 
                profesyonel olarak iş ahlakıyla çalışacak şekilde personeller temin ederek 
                gidermek ve müşterilerimizin asıl hedeflerine odaklanmalarını sağlamaktır.
              </p>
            </div>
            <div className="p-8 rounded-3xl bg-[#E76F51]/5 border border-[#E76F51]/10">
              <div className="w-14 h-14 bg-[#E76F51]/10 rounded-2xl flex items-center justify-center mb-6">
                <Eye className="text-[#E76F51]" size={28} />
              </div>
              <h2 className="text-2xl font-bold text-[#264653] mb-4 font-['Outfit']">Vizyonumuz</h2>
              <p className="text-[#264653]/70 leading-relaxed">
                Türkiye'nin lider insan kaynakları ve personel temini firması olarak, 
                sektörde güvenilirlik ve kalite standartlarını belirleyen, iş ortaklarının 
                ilk tercihi olmaktır.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="section-spacing bg-[#264653]" data-testid="values-section">
        <div className="section-container">
          <div className="text-center mb-16">
            <span className="text-[#2A9D8F] font-medium text-sm uppercase tracking-wider">
              Değerlerimiz
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-white mt-4 font-['Outfit']">
              Bizi Biz Yapan Değerler
            </h2>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {values.map((value, index) => (
              <div
                key={index}
                className="text-center p-6 rounded-2xl bg-white/5 hover:bg-white/10 transition-colors"
                data-testid={`value-${index}`}
              >
                <div className="w-16 h-16 mx-auto bg-[#2A9D8F]/20 rounded-2xl flex items-center justify-center mb-4">
                  <value.icon className="text-[#2A9D8F]" size={28} />
                </div>
                <h3 className="text-xl font-semibold text-white mb-2 font-['Outfit']">
                  {value.title}
                </h3>
                <p className="text-white/70">{value.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Legal Compliance */}
      <section className="section-spacing bg-[#FDFBF7]" data-testid="compliance-section">
        <div className="section-container">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <span className="text-[#2A9D8F] font-medium text-sm uppercase tracking-wider">
                Yasal Uyumluluk
              </span>
              <h2 className="text-3xl md:text-4xl font-bold text-[#264653] mt-4 mb-8 font-['Outfit']">
                Tam Yasal Uyumla Çalışıyoruz
              </h2>
              <div className="space-y-4">
                <div className="flex items-start gap-3">
                  <CheckCircle className="text-[#2A9D8F] shrink-0 mt-1" size={20} />
                  <div>
                    <p className="font-medium text-[#264653]">4857 Sayılı İş Kanunu</p>
                    <p className="text-[#264653]/60 text-sm">Tüm çalışma ilişkilerinde tam uyum</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <CheckCircle className="text-[#2A9D8F] shrink-0 mt-1" size={20} />
                  <div>
                    <p className="font-medium text-[#264653]">6331 Sayılı İSG Kanunu</p>
                    <p className="text-[#264653]/60 text-sm">İş sağlığı ve güvenliği standartları</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <CheckCircle className="text-[#2A9D8F] shrink-0 mt-1" size={20} />
                  <div>
                    <p className="font-medium text-[#264653]">SGK Mevzuatı</p>
                    <p className="text-[#264653]/60 text-sm">Eksiksiz sosyal güvenlik işlemleri</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <CheckCircle className="text-[#2A9D8F] shrink-0 mt-1" size={20} />
                  <div>
                    <p className="font-medium text-[#264653]">KVKK Uyumu</p>
                    <p className="text-[#264653]/60 text-sm">Kişisel verilerin korunması</p>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <img
                src="https://images.pexels.com/photos/5668858/pexels-photo-5668858.jpeg"
                alt="Yasal uyumluluk"
                className="rounded-3xl shadow-xl w-full object-cover h-[400px]"
              />
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="section-spacing bg-[#E76F51]">
        <div className="section-container text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6 font-['Outfit']">
            Birlikte Çalışalım
          </h2>
          <p className="text-white/90 max-w-xl mx-auto mb-8">
            İnsan kaynakları ihtiyaçlarınız için güvenilir çözüm ortağınız olmaya hazırız.
          </p>
          <Link
            to="/iletisim"
            className="h-12 px-8 rounded-full font-medium transition-all bg-white text-[#E76F51] hover:bg-white/90 inline-flex items-center gap-2"
            data-testid="about-cta"
          >
            İletişime Geçin <ArrowRight size={18} />
          </Link>
        </div>
      </section>
    </div>
  );
};

export default About;
